import React, { useEffect, useState } from "react";
import SmilingTeens from "../assets/smiling_teens.jpg";
import Community from "../assets/community.jpg";

export default function Services() {
  const [posts, setPosts] = useState([]);

  function xData() {
    const posts = [
      {
        image:
          "https://www.parents.com/thmb/V-UVZhOWav7T8UKtCQqBb117-ac=/900x0/filters:no_upscale():max_bytes(150000):strip_icc():gifv()/1-pregnancy-test-GettyImages-979320160-6a746f650e044d399a2be951f4d6c637.jpg",
        title: "Free Pregnancy Services",
        description:
          "We understand that pregnancy can be a challenging and emotional time, and that's why Pathway is committed to providing expectant mothers with the support and resources they need. From pregnancy testing, ultrasounds, and counseling, to prepared childbirth and baby-care classes, our team of professionals is here to help every step of the way.",
        link: "/pregnancy-services",
        accent: "from-rose-400 to-pink-400",
      },
      {
        image: SmilingTeens,
        title: "Life Skills/Risk Avoidance Curriculum",
        description:
          "Age-appropriate life skills and sexual risk avoidance curriculum written for middle-school age students and up",
        link: "/curriculum",
        accent: "from-amber-400 to-orange-400",
      },
      {
        image: Community,
        title: "Community Outreach",
        description:
          "From VBS to Parenting classes, see what we're doing in the area.",
        link: "/community-outreach",
        accent: "from-emerald-400 to-teal-400",
      },
      {
        image:
          "https://images.unsplash.com/photo-1495653797063-114787b77b23?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        title: "Emergency Services",
        description: "Contacts and assistance for a range of circumstances.",
        link: "/emergency-resources",
        accent: "from-violet-400 to-purple-400",
      },
    ];

    return { posts };
  }

  useEffect(() => {
    setPosts(xData().posts);
  }, []);

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-white via-blue-50/30 to-white py-20">
      {/* Section Header */}
      <div className="mx-auto mb-16 max-w-3xl px-6 text-center">
        <div className="mb-4 inline-block rounded-full bg-[#457B9D]/10 px-6 py-2">
          <span className="text-sm font-semibold uppercase tracking-wide text-[#457B9D]">
            Support & Resources
          </span>
        </div>
        <h2 className="mb-4 text-4xl font-semibold text-gray-800 lg:text-5xl">
          How We Can Help You
        </h2>
        <p className="text-lg text-gray-600">
          Comprehensive support services designed with you in mind
        </p>
      </div>

      {/* Services Grid */}
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="grid gap-8 sm:grid-cols-1 lg:grid-cols-2">
          {posts.map((post, index) => (
            <div
              key={post.title}
              className="group relative"
              style={{
                animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`,
              }}
            >
              {/* Card */}
              <a
                href={post.link}
                className="block h-full overflow-hidden rounded-3xl bg-white shadow-lg transition-all duration-500 hover:shadow-2xl"
              >
                {/* Image Container with Overlay */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={`${post.image}?auto=format&fit=crop&w=800&q=80`}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                    alt={post.title}
                    loading="lazy"
                  />

                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>

                  {/* Decorative Accent */}
                  <div className={`absolute right-4 top-4 h-12 w-12 rounded-full bg-gradient-to-br ${post.accent} opacity-80 blur-xl`}></div>
                </div>

                {/* Content */}
                <div className="relative p-8">
                  {/* Title */}
                  <h3 className="mb-3 text-2xl font-semibold text-gray-800 transition-colors duration-300 group-hover:text-[#457B9D]">
                    {post.title}
                  </h3>

                  {/* Description */}
                  <p className="mb-6 leading-relaxed text-gray-600">
                    {post.description}
                  </p>

                  {/* CTA */}
                  <div className="flex items-center gap-2 font-medium text-[#457B9D] transition-all duration-300 group-hover:gap-4">
                    <span>Learn More</span>
                    <svg
                      className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 8l4 4m0 0l-4 4m4-4H3"
                      />
                    </svg>
                  </div>

                  {/* Decorative Corner Element */}
                  <div className="absolute -bottom-2 -right-2 h-20 w-20 rounded-full bg-gradient-to-br from-blue-50 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100"></div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>

      {/* Add animation keyframes via inline style */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}
